export default __webpack_public_path__ + "c3f1e8393499c419a8103e744c6cdece.png";